
import { koComponent } from '../../ko-utils';
import $api from '../../api';

class CreateTour {
    constructor(params, rootPageParent) {
        this.tourName = ko.observable('').extend({ required: true });
        this.tourTag = ko.observable('');
        //this.baseUrl = ko.observable('').extend({ required: true });
        this.rootPageParent = rootPageParent;
    }

    save() {
        $api.tours.create(
            {
                projectCode: auth.project.UniqueCode
            },
            {
                name: ko.unwrap(this.tourName),
                tag: ko.unwrap(this.tourTag)
                //baseUrl: ko.unwrap(this.baseUrl)
            },
            (r) => {
                //console.log(r);
                TRACK_EVENT('Tours', 'Created');

                window.location.href = '/' + auth.project.UniqueCode + '/tours/detail/' + r.id;
            },
            (e) => {
                console.error(e);
            });
    }
}

export default koComponent('CreateTour', CreateTour);